import React from 'react';
import { Column, Row } from "../../../components/layout/FlexGrid";
import { Section } from "../../../components/Section";

export default function UsercentricsPrivacy() {
    return (
      <Section>
        <Row justifyContent="center">
          <Column large={8}>
            <div className="uc-embed" uc-layout="privacySettings"></div>
          </Column>
        </Row>
      </Section>
    );
}
